import * as React from 'react';

type IProps = {
  isLoading?: boolean,
  style?: any,
}

const LoadingIcon: React.FC<IProps> = (props) => {
  const { isLoading, style } = props;
  if (isLoading === false) { return null; }
  return (
    // WANT: Replace fontawesome
    <i className="fas fa-spinner fa-spin" style={style} />
  );
}

export default LoadingIcon;
